import React, {useEffect, useState} from 'react';
import css from './wx-pay.module.scss';
import useQuery from "hooks/useQuery";
import * as api from "api/api";
import * as antd from "antd";
import {useHistory} from "react-router-dom";
import QrCode from "components/qr-code/QrCode";


const WxPay = () => {
    const query = useQuery();
    const history = useHistory();

    useEffect(()=>{
        const timer = setInterval(() => {
            let dom = document.getElementById("bestPayForm");
            if (!dom) {
                return;
            }

            dom.submit();
            clearInterval(timer);
        }, 200)

    },[])
    useEffect(()=>{
        if(!query.orderId){
            return;
        }

        onPaySocket({orderId: query.orderId});
    },[query.orderId])

    const toPaySuccess = () => {
        history.push("/pay/success");
    }

    const onPaySocket = ({orderId}) => {
        const socket = new WebSocket(api.paySocket({orderId}));
        socket.onopen = () => {
        };

        socket.onmessage = ({data}) => {
            if (data) {
                const result = JSON.parse(data);
                if (result?.success === true) {
                    toPaySuccess();
                } else if (result?.success === false) {
                    antd.message.error(data?.errorMessage);
                    window.location.reload();
                }
            }
        }

        socket.onclose = () => {

        }
    }



    return (
        <div className={css.page}>
            <div className={css.container}>
                <img src={require('./img/left-top.png')} alt="" className={css.leftTop}/>
                <img src={require('./img/right-top.png')} alt="" className={css.rightTop}/>

                <div className={css.floor1}>
                    请及时付款，以便订单尽快处理！
                </div>

                <div className={css.floor2}>
                    <div className={css.floor2Left}>
                        <div className={css.floor2LeftTop}>
                            <img src={require('./img/wx-icon.png')} alt=""/>
                        </div>
                        <div className={css.floor2LeftCenter}>
                            <QrCode text={decodeURIComponent(query.qrCodeUrl)}/>
                        </div>
                        <div className={css.floor2LeftBottom}>
                            微信【扫一扫】完成支付
                        </div>
                    </div>
                    <div className={css.floor2Right}>
                        <div className={css.floor2RightPhone}>
                            <img src={require('./img/phone-picture.png')} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WxPay;